import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueGapi from 'vue-gapi'
import WooCommerce from './woocommerce'
import Photoshop from './photoshop'
import Dropbox from './dropbox'
import SendCloud from './sendcloud'
import GapiConfig from './gapi'

Vue.use(VueGapi, GapiConfig);
Vue.use(VueAxios, WooCommerce, Photoshop, Dropbox, SendCloud)

export default {}
